<template>
  <div class="company-info flex-box">
    <div class="content-top">
      <div class="title">{{ projectInfo.companyName }}</div>
      <div class="sub-title" v-if="projectInfo.subTitle">{{ projectInfo.subTitle }}</div>
      <div class="description">{{ projectInfo.description }}</div>
    </div>
    <div class="project-bg">
      <div class="pro-title">项目背景</div>
      <div class="paragraph" v-for="(item, k) in projectInfo.paragraph" :key="k">{{ item }}</div>
    </div>
    <div class="content-bottom">
      <div class="bottom-title">解决方案要点</div>
      <div class="carousel-container">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div v-for="(item, index) in projectInfo.caseList" class="swiper-slide" :key="index">
              <div class="case-item pointer">
                <div class="item-num">{{ item.num }}</div>
                <div class="item-content">
                  <div class="item-title">{{ item.title }}</div>
                  <div class="cl-list">
                    <div class="cl-list-item"  v-for="(subItem, sk) in item.contentList" :key="sk">
                      {{ subItem }}
                    </div>
                  </div>
                </div>
                <div class="bj"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="handle-container flex-box">
        <div class="left-btn pointer"><i class="el-icon-arrow-left" /></div>
        <div class="right-btn pointer"><i class="el-icon-arrow-right" /></div>
      </div>
    </div>
    
  </div>
</template>
<script>
import '@/static/css/swiper.min.css'
import Swiper from '@/static/js/swiper.min'
export default {
  props: {
    projectInfo: {
      type: Object,
      default: () => {
        return {
          companyName: '',
          description: '',
          redContent: '',
          content: '',
          paragraph: [],
          caseList: []
        }
      }
    }
  },
  data() {
    return {
      translateX: 0,
      swiper: null
    }
  },
  created() {
  },
  mounted() {
    this.initSwiper()
  },
  methods: {
    initSwiper() {
      this.swiper = new Swiper('.swiper-container', {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        speed: 700,
        allowTouchMove: false,
        loop: true,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        centeredSlides: true,
        on: {
          // slideChangeTransitionEnd: function(){
          //   this.slides.transition(this.params.autoplay.delay+this.params.speed).transform('translate3d(-60px, 0, 0)');
          // },
          // slideChangeTransitionStart: function(){
          //   this.slides.transition(this.params.speed).transform('translate3d(0, 0, 0)');
          // },
        },
        navigation: {
          nextEl: '.right-btn',
          prevEl: '.left-btn',
        }
      });
      this.swiper.el.onmouseover = function(){
        this.swiper.autoplay.stop();
      }
      this.swiper.el.onmouseout = function(){
        this.swiper.autoplay.start();
      }
    },
    moveToLeft() {
      this.translateX -= 46;
      if (this.translateX < -84) this.translateX = -84
    },
    moveToRight() {
      this.translateX += 46;
      if (this.translateX > 0) this.translateX = 0
    }
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.company-info {
  flex-direction: column;
  align-items: center;
  background-color: #FFFFFF;
  position: relative;

  .project-bg {
    position: absolute;
    top: 22rem;
    left: 26rem;
    width: 140rem;
    height: 35.5rem;
    background: #FFFFFF;
    box-shadow: 0rem 0.5rem 4rem 0rem #D6E2E2;
    padding: 6rem 9rem;
    .pro-title {
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 3.2rem;
      color: #333333;
      line-height: 3.6rem;
      font-style: normal;
    }
    .paragraph {
      font-size: 2.2rem;
      line-height: 3.6rem;
      font-weight: 400;
      color: #333333;
      text-align: left;
      margin-top: 3rem;
      &::before {
        content: '◇ ';
      }
    }
  }

  .content-top {
    text-align: center;
    width: 100%;
    height: 51.5rem;
    padding-top: 9rem;
    .title {
      font-size: 4rem;
      font-weight: 600;
      color: #333333;
      line-height: 4rem;
      margin-bottom: 2.4rem;
    }
    .sub-title {
      font-size: 2.4rem;
      font-weight: 600;
      color: #333333;
      line-height: 2.4rem;
      margin-bottom: 1.4rem;
    }

    .description {
      font-size: 1.8rem;
      font-weight: 400;
      color: #666A77;
      line-height: 1.8rem;
      margin-bottom: 4.2rem;
    }
  }
  

  .content-bottom {
    height: 81.8rem;
    width: 100%;
    background: url("#{$img}/ydbg1.png");
    background-size: cover!important;
    background-repeat: no-repeat!important;
    padding: 14rem 26rem 0;
    .bottom-title {
      height: 4rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 4rem;
      color: #333333;
      line-height: 4rem;
      text-align: center;
      font-style: normal;
      text-transform: uppercase;
      margin-bottom: 4.5rem;
    }
    .handle-container {
      width: 100%;
      height: 12.2rem;
      justify-content: center;

      .left-btn, .right-btn {
        width: 4.2rem;
        height: 4.2rem;
        border-radius: 50%;
        background-size: cover!important;
        background-repeat: no-repeat!important;
        display: flex;
        justify-content: center;
        align-items: center;

        i {
          font-size: 2rem;
        }
      }
      .left-btn {
        background: #fff;
        margin-right: 1.7rem;
        box-shadow: 0 0.1rem 1.2rem 0 rgba(0,0,0,0.1);

        &:active {
          box-shadow: 0 0.2rem 2rem 0 rgba(0,0,0,0.1);
        }
      }
      .right-btn {
        color: #fff;
        background: #f65733;
        box-shadow: 0 0.1rem 1.2rem 0 rgba(219, 154, 137, 1);

        &:active {
          box-shadow: 0 0.2rem 2rem 0 rgb(219, 154, 137);
        }
      }
    }
    .carousel-container {
      width: 100%;
      height: 52.6rem;
      overflow: visible;
      position: relative;
      display: flex;

      &:hover {
        animation-play-state: paused;
      }

      .case-item {
        width: 40rem;
        height: 48rem;
        background: #fff;
        border-radius: 1.2rem;
        border: 0.1rem solid #FFFFFF;
        margin: 0 auto;
        position: relative;
        padding: 6.2rem 4rem 0;

        &:hover {
          box-shadow: 0 0.2rem 3.2rem 0 rgba(0,0,0,0.1);
          background: linear-gradient( 161deg, #588CFF 0%, #3674FE 100%);
          .item-content {
            color: #FFFFFF;
          }
        }

        .item-num {
          position: absolute;
          left: 4rem;
          top: 3rem;
          font-family: DINAlternate, DINAlternate;
          font-weight: bold;
          font-size: 4.8rem;
          color: #EAF1FE;
          line-height: 5.6rem;
          text-align: left;
          font-style: normal;
          opacity: .5;
        }
        .bj {
          width: 13.9rem;
          height: 11.1rem;
          position: absolute;
          bottom: 0;
          right: 0;
          background: url("#{$img}/jjfabj.png");
          background-size: cover!important;
          background-repeat: no-repeat!important;
        }
        .item-content {
          position: absolute;
          top: 6.2rem;
          left: 4rem;
          width: calc(100% - 8rem);
          color: #333333;
          .item-title {
            margin-bottom: 1.8rem;
            height: 2.8rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 2.8rem;
            line-height: 2.8rem;
            text-align: left;
            font-style: normal;
          }
          .cl-list {
            .cl-list-item {
              position: relative;
              font-weight: 400;
              font-size: 1.6rem;
              line-height: 2.4rem;
              text-align: left;
              font-style: normal;
              margin-bottom: 2rem;
              &::before {
                content: '◇ ';
              }
            }
          }
        }
        




   
      }
    }
    .carousel-container {

      .swiper-container {
        padding-bottom:40px;
      }
      .swiper-wrapper{
      }
      .swiper-slide {
        width: 44rem;
        transition-timing-function:linear;
      }
      .ani {
        transition-timing-function:linear;
      }
      .swiper-slide img{
        width:100%;
        border-radius: 4px;
      }
    }
  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .company-info {
    .content-top {
      height: auto;
      padding: 4.8rem 1.6rem 2.4rem;
      .title {
        font-size: 2.4rem !important;
        line-height: 3.2rem !important;
      }
      .sub-title {
        font-size: 1.6rem;
        line-height: 2.2rem;
      }
      .description {
        font-size: 1.4rem;
        line-height: 2.2rem;
        white-space: normal;
        word-break: break-word;
      }
    }
    .project-bg {
      position: relative;
      top: auto;
      left: auto;
      width: calc(100% - 3.2rem);
      height: auto;
      margin: 0 1.6rem 2.4rem;
      padding: 2.4rem 1.6rem;
      .pro-title {
        font-size: 1.8rem;
        line-height: 2.4rem;
      }
      .paragraph {
        font-size: 1.4rem;
        line-height: 2.2rem;
        margin-top: 1.2rem;
        white-space: normal;
        word-break: break-word;
      }
    }
    .content-bottom {
      height: auto;
      padding: 4.8rem 1.6rem 2.4rem;
    }
    .carousel-container {
      height: auto;
      .case-item {
        width: 28rem;
        height: auto;
        padding: 4rem 1.6rem 2.4rem;
        overflow: visible;
        .item-content {
          position: relative;
          top: auto;
          left: auto;
          width: 100%;
        }
        .item-title {
          height: auto;
          white-space: normal;
          word-break: break-word;
          overflow-wrap: break-word;
          line-height: 2.8rem;
        }
        .cl-list-item {
          white-space: normal;
          word-break: break-word;
          overflow-wrap: break-word;
          line-height: 2.2rem;
        }
      }
      .swiper-slide {
        width: 30rem;
      }
    }
  }
}
</style>
